import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importWithdrawalContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "WithdrawalContainer" */
                '@perpay-web/fintech/components/containers/WithdrawalContainer'
            ),
    );
